module.exports = __webpack_public_path__ + "img/HTIT-WB32-C.2f5de4f4.jpg";